import axios from "axios";
import React, { useState, useEffect } from "react";
import { pageTitle } from "../../helpers/PageTitle";
import "../../sass/shortcode/Signinup.scss";
import BannerSectionStyle5 from "../Section/BannerSection/BannerSectionStyle5";
import { BASE_URL } from "../../helpers/api";
import { Link } from "react-router-dom";

import { FaEye, FaEyeSlash } from "react-icons/fa";

export default function SignIn() {
  pageTitle("Sign In");

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  // Load saved email on first render
  useEffect(() => {
    const savedEmail = localStorage.getItem("rememberedEmail");
    if (savedEmail) {
      setEmail(savedEmail);
      setRememberMe(true);
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Handle Remember Me
    if (rememberMe) {
      localStorage.setItem("rememberedEmail", email);
    } else {
      localStorage.removeItem("rememberedEmail");
    }

    try {
      const res = await axios.post(
        `${BASE_URL}/auth/login`,
        { email, password },
        { headers: { "Content-Type": "application/json" } }
      );

      alert("Login successful");

      const { user, token, role } = res.data;
      const patientId = res.data.user.patient_id;

      const storage = rememberMe ? localStorage : sessionStorage;

      storage.setItem("userId", user.id);
      storage.setItem("userRole", user.role ?? "patient");
      storage.setItem("userEmail", user.email);
      storage.setItem("userName", [user.firstname, user.lastname].filter(Boolean).join(" ").trim());
      storage.setItem("userPhone", user.mobile);
      storage.setItem("token", token);
      storage.setItem("patientId", res.data.user.patient_id);

      // Redirect based on role
      // if (role === "admin") {
      //   window.location.href = "/admin/dashboard";
      // } else if (role === "doctor") {
      //   window.location.href = "/doctor/dashboard";
      // } else {
      //   window.location.href = "/patientprofile";
      // }

      // Redirect based on role
      if (role === "admin") {
        window.location.href = "/admin/dashboard";
      } else if (role === "doctor") {
        window.location.href = "/doctor/dashboard";
      } else {
        // Check if user came from booking flow
        const redirect = localStorage.getItem("redirectAfterLogin");
        if (redirect) {
          localStorage.removeItem("redirectAfterLogin");
          window.location.href = redirect;
        } else {
          window.location.href = "/patientprofile";
        }
      }
    } catch (err) {
      console.error(err);
      alert("Please check your email and password");
    }
  };

  return (
    <>
      <BannerSectionStyle5
        bgUrl="/images/contact/banner_bg.svg"
        imgUrl="/images/Signin.png"
        title="Welcome Back!"
        subTitle="Login to access your personalized dashboard, manage your appointments, and stay connected with your healthcare journey"
      />

      <div className="signin-container">
        <div className="signin-wrapper">
          {/* LEFT IMAGE */}
          <div className="signin-left">
            <img
              src="/images/auth-img.png"
              alt="Login Illustration"
              className="signin-image"
            />
          </div>

          {/* RIGHT FORM */}
          <div className="signin-form">
            <h2 className="signin-title">Sign In to your Account</h2>
            <p className="signin-subtitle">Welcome back! Please enter your details</p>

            <form onSubmit={handleSubmit}>
              {/* EMAIL */}
              <div className="form-group">
                <label>Email</label>
                <input
                  type="email"
                  className="form-input"
                  placeholder="Enter your Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value.toLowerCase())}
                  required
                />
              </div>

              {/* PASSWORD WITH EYE ICON */}
              <div className="form-group" style={{ position: "relative" }}>
                <label>Password</label>

                <input
                  type={showPassword ? "text" : "password"}
                  className="form-input"
                  placeholder="Enter your password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />

                {/* Eye Icon */}
                <span
                  onClick={() => setShowPassword(!showPassword)}
                  style={{
                    position: "absolute",
                    right: "12px",
                    top: "70%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    fontSize: "20px",
                    color: "#555",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100%",
                  }}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </span>
              </div>

              {/* REMEMBER ME + FORGOT PASSWORD */}
              <div className="form-options">
                <label className="remember-me" style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                  <input
                    type="checkbox"
                    checked={rememberMe}
                    onChange={(e) => setRememberMe(e.target.checked)}
                  />
                  Remember me
                </label>

                <Link to="/forgot-password" className="forgot-password">
                  Forgot Password?
                </Link>
              </div>

              {/* SUBMIT BUTTON */}
              <button type="submit" className="submit-button">
                Sign In
              </button>

              {/* SIGN UP LINK */}
              <p className="signup-link">
                Don’t have an account? <Link to="/signup">Sign Up</Link>
              </p>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}